import { render, staticRenderFns } from "./IntegrationFormTeams.vue?vue&type=template&id=78ee1fac&scoped=true"
import script from "./IntegrationFormTeams.vue?vue&type=script&lang=js"
export * from "./IntegrationFormTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee1fac",
  null
  
)

export default component.exports